import { Popover, Typography, Flex } from 'antd';
import { CopyOutlined, PhoneOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useCopyToClipboard } from 'shared/hooks/use-copy-to-clipboard';
import styles from './manager-info-popover.module.scss';
import type { IManagerInfoPopoverProps } from './types';

const { Text } = Typography;

export const ManagerInfoPopover: React.FC<IManagerInfoPopoverProps> = ({ user }) => {
  const copy = useCopyToClipboard();

  const content = (
    <Flex gap={20} className={styles.wrapper} vertical>
      <Flex gap={10} align='center'>
        <Text>{user.email}</Text>
        <CopyOutlined className={classNames(styles.copyIcon, 'hover')} onClick={() => copy(user.email)} />
      </Flex>
      {user.phone && (
        <Flex vertical>
          <Flex gap={10} align='center'>
            <Text>{user.phone}</Text>
            <CopyOutlined className={classNames(styles.copyIcon, 'hover')} onClick={() => copy(user.phone as string)} />
          </Flex>
          {user.phoneDescription && <Text type='secondary'>{user.phoneDescription}</Text>}
        </Flex>
      )}
    </Flex>
  );
  return (
    <Popover content={content} placement='bottom' title={null} trigger='click' arrow={{ pointAtCenter: true }}>
      <PhoneOutlined className='hover' />
    </Popover>
  );
};
